import React from "react";
import { Box, Button, Stack } from "@mui/material";
import dayjs from "dayjs";
import { INV_HISTORY_ACTION_TYPE } from "Common";

const InvHistoryItem = ({ invHistory, handleDelete, handleEdit }) => {

    return (
        <Stack direction="row" sx={{ alignItems: 'center', pl: 1 }}>
            <Box sx={{ flex: 4, textAlign: "left" }}>{dayjs(invHistory.ActionDate).format('YYYY/MM/DD')}</Box>
            <Box sx={{ flex: 4, textAlign: "center" }}>{INV_HISTORY_ACTION_TYPE[invHistory.ActionType]}</Box>
            <Box sx={{ flex: 3, textAlign: "right" }}>在庫数</Box>
            <Box sx={{ flex: 2, textAlign: "right" }}>{invHistory.NumberQ}</Box>
            <Stack direction="row" sx={{ ml: 1 }}>
                <Button size="small" sx={{ width: 40, minWidth: 0 }} color="secondary"
                    onClick={() => { if (handleDelete) handleDelete(invHistory); }}
                >削除</Button>
                <Button size="small" sx={{ width: 40, minWidth: 0 }}
                    onClick={() => { if (handleEdit) handleEdit(invHistory); }}
                >編集</Button>
            </Stack>
        </Stack>
    )
}
export default InvHistoryItem;